import React, { useContext, useEffect, useState } from "react";
import { createPopper } from "@popperjs/core";
import { Badge, Box, IconButton, Typography } from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";
import {
  CheckCircleOutline,
  CloseOutlined,
  ErrorOutline,
  Notifications,
  NotificationsOutlined,
  Warning,
} from "@mui/icons-material";
import axios from "axios";
import { useHistory } from "react-router";
import SocketContext from "helpers/SocketContext";

const NotificationDropdown = (props) => {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const socket = useContext(SocketContext);
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  const [notifications, setNotifications] = useState(props.notifications);

  const clearAllNotifications = async () => {
    const deleteNotification = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/api/notification/`
    );
    if (deleteNotification.status === 200) {
      setNotifications([]);
      closeDropdownPopover();
    }
  };

  const markAllAsRead = async () => {
    setIsLoading(true);
    const markAllAsRead = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/api/notification/markAllAsRead`
    );
    if (markAllAsRead.status === 200) {
      setNotifications(
        notifications.map((notification) => ({ ...notification, isRead: true }))
      );
      setIsLoading(false);
    }
  };

  const markAsRead = async (id) => {
    setIsLoading(true);
    const markAsRead = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/api/notification/${id}`
    );
    if (markAsRead.status === 200) {
      setNotifications(
        notifications.map((notification) =>
          notification.id === id
            ? { ...notification, isRead: true }
            : notification
        )
      );
      setIsLoading(false);
    }
  };

  const deleteNotification = async (id) => {
    setIsLoading(true);
    const deleteNotification = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/api/notification/${id}`
    );
    if (deleteNotification.status === 200) {
      setNotifications(
        notifications.filter((notification) => notification.id !== id)
      );
      setIsLoading(false);
      // close the dropdown if there are no notifications
      if (notifications.length === 1) {
        closeDropdownPopover();
      }
    }
  };

  const renderIcon = (type) => {
    switch (type) {
      case "success":
        return <CheckCircleOutline className="text-green-500" />;
      case "error":
        return <ErrorOutline className="text-red-500" />;
      case "warning":
        return <Warning className="text-yellow-500" />;
      default:
        return null;
    }
  };

  useEffect(() => {
    setNotifications(props.notifications);
  }, [props.notifications]);

  return (
    <div>
      {/* <Badge color="secondary" badgeContent=" ">
        aa
      </Badge> */}
      <IconButton
        sx={{
          backgroundColor: "#FFFFFF",
        }}
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <Badge
          color="error"
          variant={notifications?.length === 0 ? "dot" : "standard"}
          invisible={notifications?.length === 0}
          overlap="circular"
          badgeContent={notifications?.filter((i) => i.isRead === false).length}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <NotificationsOutlined className="text-primary group-hover:text-gray-50" />
        </Badge>
      </IconButton>

      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base overflow-y-auto h-48  z-50 float-left py-2 list-none text-left rounded shadow-lg mt-1 min-w-48"
        }
      >
        <Box
          sx={{
            padding: 2,
          }}
          className={
            (dropdownPopoverShow ? "block " : "hidden ") +
            "bg-white text-base z-50 float-left py-2 list-none text-left rounded  mt-1 max-w-48 h-32"
          }
        >
          <div className="flex justify-between items-center mb-4">
            <Typography variant="h6">Notifications</Typography>
            <IconButton onClick={closeDropdownPopover}>
              <IoMdCloseCircleOutline className="text-gray-500" />
            </IconButton>
          </div>

          {/* clear all  */}
          {notifications?.length > 0 && (
            <div className="flex justify-between mb-4">
              <Typography
                variant="body2"
                className="text-blue-400 cursor-pointer"
                onClick={markAllAsRead}
              >
                Mark All as Read
              </Typography>
              <Typography
                variant="body2"
                className="text-blue-500 cursor-pointer"
                onClick={clearAllNotifications}
              >
                Clear All
              </Typography>
            </div>
          )}

          {/* Notification List */}
          <div
            className=""
            style={{
              maxHeight: "500px",
            }}
          >
            {notifications?.length === 0 && (
              <div className="flex justify-center items-center h-full">
                <Typography variant="body1" className="text-gray-500">
                  No notifications
                </Typography>
              </div>
            )}
            {notifications &&
              notifications?.map((notification) => (
                <div
                  key={notification.id}
                  className={`${
                    notification?.isRead ? "border-gray-200" : " border-red-500"
                  }  bg-gray-50 p-4 mb-4 rounded-lg shadow flex items-center  border`}
                >
                  {/* Icon based on notification type */}
                  {renderIcon(notification.type)}

                  {/* Message */}
                  <Typography
                    variant="body1"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (!notification.isRead) {
                        // socket.emit("readNotification", {
                        //   receiverId: props.loggedUser.Resource.id,
                        //   notificationId: notification.id,
                        // });
                        markAsRead(notification.id);
                      }

                      if (notification.type === "project_assigned") {
                        history.push(
                          `/admin/project/details/${notification.projectId}`
                        );
                        props?.SetSelectedMenu &&
                          props.SetSelectedMenu({
                            title: "Project Management",
                          });
                        closeDropdownPopover();
                      } else if (
                        notification.type === "leave_approved" &&
                        notification.requestId
                      ) {
                        history.push(
                          `/admin/permission/details/${notification.requestId}`
                        );
                        props?.SetSelectedMenu &&
                          props.SetSelectedMenu({ title: "My Leave" });
                        closeDropdownPopover();
                      } else if (
                        notification.type === "leave_created" &&
                        notification.requestId
                      ) {
                        history.push(
                          `/admin/permission/details/${notification.requestId}`
                        );
                        props?.SetSelectedMenu &&
                          props.SetSelectedMenu({ title: "My Leave" });
                        closeDropdownPopover();
                      } else if (
                        (notification.type === "task_assigned" ||
                          notification.type === "attachment" ||
                          notification.type === "comment") &&
                        notification.taskId
                      ) {
                        history.push(`/admin/task/${notification.taskId}`);
                        props?.SetSelectedMenu &&
                          props.SetSelectedMenu({ title: "Task Management" });
                        closeDropdownPopover();
                      }
                    }}
                    className="flex-grow"
                  >
                    {notification.message}
                  </Typography>

                  {/* Close Button */}
                  <IconButton
                    onClick={() => {
                      deleteNotification(notification.id);
                    }}
                  >
                    <CloseOutlined className="text-gray-500" />
                  </IconButton>
                </div>
              ))}
          </div>
        </Box>
      </div>
    </div>
  );
};

export default NotificationDropdown;
